import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, catchError, Observable, of, Subject, takeUntil, tap } from 'rxjs';
import { ValidationCheckStatus } from '../../../../shared/types';
import { CampaignService } from 'src/app/shared/services/requests/campaign.service';

@Component({
  selector: 'app-email-account-tracking-domain',
  templateUrl: './email-account-tracking-domain.component.html',
  styleUrls: ['./email-account-tracking-domain.component.scss'],
  standalone: false,
})
export class EmailAccountTrackingDomainComponent implements OnInit, OnDestroy {
  constructor(private campaignService: CampaignService) {}

  @Input() domainTrackingNameControl: FormControl<string>;

  private validationStateSubject = new BehaviorSubject<ValidationCheckStatus>('idle');
  private $unsubscribe = new Subject<void>();

  $validationState: Observable<ValidationCheckStatus> = this.validationStateSubject.asObservable();

  ngOnInit(): void {
    this.domainTrackingNameControl.valueChanges.pipe(takeUntil(this.$unsubscribe)).subscribe(() => {
      const trimed = this.domainTrackingNameControl.value.trim();
      if (this.domainTrackingNameControl.value != trimed) {
        this.domainTrackingNameControl.setValue(trimed);
        return;
      }

      this.validationStateSubject.next('idle');
    });
  }

  verifyDomain(): void {
    this.validationStateSubject.next('loading');
    this.domainTrackingNameControl.disable({ emitEvent: false });

    const domain = this.domainTrackingNameControl.value;
    this.campaignService
      .verifyTrackingDomain(domain)
      .pipe(
        takeUntil(this.$unsubscribe),
        tap((valid: boolean) => {
          this.validationStateSubject.next(valid ? 'ok' : 'failed');
        }),
        catchError(() => {
          this.validationStateSubject.next('idle');
          return of(null);
        }),
      )
      .subscribe(() => {
        this.domainTrackingNameControl.enable({ emitEvent: false });
      });
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
